import { render, staticRenderFns } from "./MyMai.vue?vue&type=template&id=4c628846&scoped=true&"
import script from "./MyMai.vue?vue&type=script&lang=js&"
export * from "./MyMai.vue?vue&type=script&lang=js&"
import style0 from "./MyMai.vue?vue&type=style&index=0&id=4c628846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c628846",
  null
  
)

export default component.exports